// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4072":"ee9a0804","6916":"c9fe8b55"}[chunkId] + ".chunk.css";
};